import { Component, OnInit } from '@angular/core';
import { WriteFileResult } from '@capacitor/filesystem';
import { AlertController, ModalController } from '@ionic/angular';
import { GenericResponse, RecordingData, VoiceRecorder } from 'capacitor-voice-recorder';
import { FileService } from 'src/app/services/app/file.service';

@Component({
  selector: 'app-c-modal-record-audio',
  templateUrl: './c-modal-record-audio.component.html',
  styleUrls: ['./c-modal-record-audio.component.scss'],
})
export class CModalRecordAudioComponent implements OnInit {
  recording = false;
  timeLimit = 30;
  timeOut: any;
  trackTimeRecordingInterval: any;
  timeRecording = 0;

  resultStopRecording: { writeFileResult: WriteFileResult; recordingData: RecordingData; } | undefined;
  canDeviceVoiceRecord = VoiceRecorder.canDeviceVoiceRecord();

  constructor(
    private alertController: AlertController,
    private fileService: FileService,
    private modalController: ModalController,
  ) { }

  ngOnInit() {
    this.requestAudioRecordingPermission().then(_ => {
      if (typeof _ === 'string') {
        this.closeModal();
        this.alertController.create({
          message: _,
          buttons: [
            {
              text: `OK`,
            }
          ]
        }).then(alrt => alrt.present())
      }
    })
  }

  requestAudioRecordingPermission(): Promise<boolean | string> {
    const canDeviceVoiceRecord: Promise<GenericResponse> = this.canDeviceVoiceRecord.catch(_ => ({ value: false }));
    const hasAudioRecordingPermission: Promise<GenericResponse> = VoiceRecorder.hasAudioRecordingPermission().catch(_ => ({ value: false }));
    return Promise.all([
      canDeviceVoiceRecord,
      hasAudioRecordingPermission
    ]).then(vals => {
      if (!vals[0].value) {
        return `Votre appareil ne vous permet pas de prendre d'enregistrement audio.`;
      }
      if (!vals[1].value) {
        return VoiceRecorder.requestAudioRecordingPermission().then(response => {
          return response.value || `Vous n'avez pas autorisé l'appareil à prendre des enregistrements audios.`
        })
      }
      return true;
    })
  }


  startRecording() {
    if (this.recording) {
      return;
    }
    this.timeRecording = 0;
    VoiceRecorder.startRecording().then(e => {
      this.recording = true;
      this.timeOut = setTimeout(() => {
        this.stopRecording();
      }, this.timeLimit * 1000);
      this.trackTimeRecordingInterval = setInterval(() => {
        this.timeRecording += 100;
      }, 100);
    });

  }

  stopRecording() {
    if (!this.recording) {
      return;
    }
    this.recording = false;
    if (this.timeOut) {
      clearTimeout(this.timeOut);
      this.timeOut = undefined;
    }
    if (this.trackTimeRecordingInterval) {
      clearInterval(this.trackTimeRecordingInterval);
      this.trackTimeRecordingInterval = undefined;
    }
    const stopRecordingP = VoiceRecorder.stopRecording();
    if (stopRecordingP !== undefined) {
      stopRecordingP.then(async (recordingData: RecordingData) => {
        this.timeRecording = Math.ceil(recordingData.value.msDuration / 1000) * 1000;
        if (recordingData.value && recordingData.value.recordDataBase64) {
          this.treatAudioFile(recordingData).then(infos => {
            this.closeModal(infos);
          })
        }
      })
    }
  }

  cancelRecording() {
    this.recording = false;
    if (this.timeOut) {
      clearTimeout(this.timeOut);
      this.timeOut = undefined;
    }
    if (this.trackTimeRecordingInterval) {
      clearInterval(this.trackTimeRecordingInterval);
      this.trackTimeRecordingInterval = undefined;
    }
    VoiceRecorder.stopRecording();
    this.closeModal();
  }

  treatAudioFile(fileDatas: RecordingData): Promise<{ filePath: string, fullDataBase64: string }> {
    const mimeTypeAndExtension = this.audioMimeTypeToMimeTypeAndExtension(fileDatas.value.mimeType)
    const fullDataBase64 = `data:${mimeTypeAndExtension.mimetype};base64,${fileDatas.value.recordDataBase64}`;
    return this.fileService.copyInCache(fullDataBase64, this.generatefileName('audio_', mimeTypeAndExtension.extension))
    .then(result => ({
      filePath: result.uri,
      fullDataBase64
    }))
  }

  generatefileName(prefix = 'audio_', extension: string) {
    const date = new Date();
    const year = `0000${date.getFullYear()}`.slice(-4);
    const month = `00${date.getMonth() + 1}`.slice(-2);
    const day = `00${date.getDate()}`.slice(-2);

    const hours = `00${date.getHours()}`.slice(-2);
    const minutes = `00${date.getMinutes()}`.slice(-2);
    const seconds = `00${date.getSeconds()}`.slice(-2);

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${extension}`
  }

  public async closeModal(infos?: any): Promise<void> {
    this.modalController.dismiss(infos);
  }


  audioMimeTypeToMimeTypeAndExtension(mimeType: string) {
    const found = [
      {extension: '.aac', mimetype: 'audio/aac'},
      {extension: '.midi', mimetype: 'audio/midi'},
      {extension: '.oga', mimetype: 'audio/ogg'},
      {extension: '.wav', mimetype: 'audio/x-wav'},
      {extension: '.weba', mimetype: 'audio/webm'},
      {extension: '.mp3', mimetype: 'audio/mpeg'},
    ].find(elem => mimeType.indexOf(elem.mimetype) > -1);
    if (found) {
      return found;
    } else {
      return {extension: '.mp3', mimetype: 'audio/mpeg'};
    }
  }

}
